/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseRefusalDeltaEvent = {
  type: "response.refusal.delta";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  contentIndex: number;
  delta: string;
};

/** @internal */
export const ResponseRefusalDeltaEvent$inboundSchema: z.ZodType<
  ResponseRefusalDeltaEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.refusal.delta"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  content_index: z.number().int(),
  delta: z.string(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
    "content_index": "contentIndex",
  });
});
/** @internal */
export type ResponseRefusalDeltaEvent$Outbound = {
  type: "response.refusal.delta";
  sequence_number: number;
  item_id: string;
  output_index: number;
  content_index: number;
  delta: string;
};

/** @internal */
export const ResponseRefusalDeltaEvent$outboundSchema: z.ZodType<
  ResponseRefusalDeltaEvent$Outbound,
  z.ZodTypeDef,
  ResponseRefusalDeltaEvent
> = z.object({
  type: z.literal("response.refusal.delta"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  contentIndex: z.number().int(),
  delta: z.string(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
    contentIndex: "content_index",
  });
});

export function responseRefusalDeltaEventToJSON(
  responseRefusalDeltaEvent: ResponseRefusalDeltaEvent,
): string {
  return JSON.stringify(
    ResponseRefusalDeltaEvent$outboundSchema.parse(responseRefusalDeltaEvent),
  );
}
export function responseRefusalDeltaEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseRefusalDeltaEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseRefusalDeltaEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseRefusalDeltaEvent' from JSON`,
  );
}
